import { translate } from '@fiverr-private/i18n-react';

export const translateCategoryName = (categoryId) => translate(`categories.category_${categoryId}.name`);

export const translateSubCategoryName = (subCategoryId) =>
    translate(`sub_categories.sub_category_${subCategoryId}.name`);

export const translateNestedSubCategoryName = (subCategoryId, nestedSubCategoryId) =>
    translate(`sub_categories.sub_category_${subCategoryId}.nested_sub_cat_${nestedSubCategoryId}.name`);
